const WaitingIcon = ({ color }: any) => {
  return (
    <svg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.00033 13.3327C10.222 13.3327 12.8337 10.721 12.8337 7.49935C12.8337 4.27769 10.222 1.66602 7.00033 1.66602C3.77866 1.66602 1.16699 4.27769 1.16699 7.49935C1.16699 10.721 3.77866 13.3327 7.00033 13.3327Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7 4V7.5L9.33333 8.66667'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default WaitingIcon
